import { createSelector } from '@reduxjs/toolkit';

import { queryString } from '../helpers/query-filter';
import List from '../models/list';
import type { RootState } from '../reducers';

export const getList = createSelector(
  (state: RootState) => state.list.documentList,
  (documentList) => {
    if (!documentList) {
      return [];
    }

    return documentList.documents.filter((d) => !!d).map(List.parse);
  },
);

export const getCurrentListPage = (state: RootState, slug: string) => {
  const list = getList(state);
  if (list) {
    const index = slug.indexOf('?');
    let formattedSlug = slug;
    if (index > -1) {
      formattedSlug = slug.slice(0, index);
    }
    const page = list.find((x) => x.slug === formattedSlug);
    return page ? page : null;
  }
  return null;
};

export const isListPage = (state: RootState, slug: string) => !!getCurrentListPage(state, slug);

export const getCurrentListPageQueryFilter = (state: RootState, slug: string) => {
  const page = getCurrentListPage(state, slug);
  if (page) {
    const qf = queryString('qf', `https//:www.wayke.se/sok?${page.queryFilter}`);
    return qf;
  }
  return null;
};

export const getCurrentListPageFromQueryUrl = (state: RootState) => {
  if (!process.env.SSR) {
    const url = window.location.search;
    const re = /[?&]list(=([^&#]*)|&|#|$)/;
    const results = re.exec(url);

    const res = !results || !results[2] ? null : results[2].replace(/\+/g, ' ');
    if (res) return getCurrentListPage(state, res);
  }
  return null;
};

export const getListItemHitCount = createSelector(
  (state: RootState) => state.list.hits,
  (_: RootState, id?: string) => id,
  (hits, id) => {
    if (!id) return null;
    const count = hits?.[id];
    return count !== undefined && !Number.isNaN(count) ? count : null;
  },
);

export const getListById = (state: RootState, id: string) => {
  const list = getList(state);
  const match = list.find((x) => x.id === id);
  return match ? match : null;
};
